/**
 * Single source of values: `globalSettingsDefaults.json`.
 *
 * - Frontend / Vite: import from this file or `@merlot/common/globalSettingsDefaults.js`.
 * - Backend CommonJS: `require('.../common/globalSettingsDefaults.json')`.
 */

import data from './globalSettingsDefaults.json' assert { type: 'json' };

export const GLOBAL_SETTINGS_DEFAULTS = data.defaults;
export const GLOBAL_SETTINGS_LIMITS = data.limits;
export const GLOBAL_SETTINGS_HARD_LIMITS = data.hardLimits;
